(() => {
  'use strict';

  const API = 'https://product.bowkart.com';
  const SHOPPER_URL = `${API}/api/ai-shopper`;
  const BRAIN_URL = `${API}/api/brain-recommend`;
  const EVENT_URL = `${API}/api/ai-shopper-event`;

  const root = document.getElementById('bk-ai-shopper');
  if (!root) return;

  const launcher = document.getElementById('bkAiLauncher');
  const drawer = document.getElementById('bkAiDrawer');
  const overlay = document.getElementById('bkAiOverlay');
  const closeBtn = document.getElementById('bkAiClose');
  const form = document.getElementById('bkAiForm');
  const input = document.getElementById('bkAiInput');
  const send = document.getElementById('bkAiSend');
  const welcome = document.getElementById('bkAiWelcome');
  const conversation = document.getElementById('bkAiConversation');
  const results = document.getElementById('bkAiResults');
  const toast = document.getElementById('bkAiToast');

  const STORAGE_SESSION = 'bk_ai_shopper_session_v3';
  const STORAGE_MEMORY = 'bk_ai_shopper_memory_v3';

  const RECOMMENDATION_LIMIT = 12;

  let memory = readJson(STORAGE_MEMORY, {
    context: {},
    shown_handles: [],
    last_query: '',
    page: 0
  });

  let busy = false;

  function readJson(key, fallback) {
    try {
      const v = JSON.parse(localStorage.getItem(key) || '');
      return v && typeof v === 'object' ? v : fallback;
    } catch (_) {
      return fallback;
    }
  }

  function saveMemory() {
    localStorage.setItem(
      STORAGE_MEMORY,
      JSON.stringify(memory)
    );
  }

  function sessionId() {
    let id = localStorage.getItem(STORAGE_SESSION);

    if (!id) {
      id =
        window.crypto && crypto.randomUUID
          ? crypto.randomUUID()
          : `bk-${Date.now()}-${Math.random()
              .toString(36)
              .slice(2)}`;

      localStorage.setItem(
        STORAGE_SESSION,
        id
      );
    }

    return id;
  }

  function money(paise) {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(Number(paise || 0) / 100);
  }

  function esc(s) {
    return String(s ?? '').replace(
      /[&<>"']/g,
      m =>
        ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;'
        }[m])
    );
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute(
      'aria-hidden',
      'false'
    );

    launcher.setAttribute(
      'aria-expanded',
      'true'
    );

    overlay.hidden = false;

    document.documentElement.style.overflow =
      'hidden';

    setTimeout(() => input.focus(), 150);

    track('shopper_open');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');

    drawer.setAttribute(
      'aria-hidden',
      'true'
    );

    launcher.setAttribute(
      'aria-expanded',
      'false'
    );

    overlay.hidden = true;

    document.documentElement.style.overflow =
      '';
  }

  function showToast(msg, error = false) {
    toast.textContent = msg;

    toast.style.background = error
      ? '#9b4455'
      : '#2f7d5c';

    toast.hidden = false;

    clearTimeout(showToast._t);

    showToast._t = setTimeout(
      () => {
        toast.hidden = true;
      },
      2600
    );
  }

  function bubble(text, who, intent) {
    const d = document.createElement('div');

    d.className =
      `bk-ai__bubble bk-ai__bubble--${who}`;

    let html = esc(text);

    if (who === 'ai' && intent) {
      const chips = [];

      if (intent.age) {
        chips.push(
          `Age: ${esc(intent.age)}`
        );
      }

      if (intent.category) {
        chips.push(
          `Category: ${esc(intent.category)}`
        );
      }

      if (intent.occasion) {
        chips.push(
          `Occasion: ${esc(intent.occasion)}`
        );
      }

      const colors =
        Array.isArray(intent.colors)
          ? intent.colors
          : intent.color
            ? [intent.color]
            : [];

      if (colors.length) {
        chips.push(
          `Color: ${esc(colors.join(', '))}`
        );
      }

      if (intent.material) {
        chips.push(
          `Material: ${esc(intent.material)}`
        );
      }

      if (intent.max_price != null) {
        chips.push(
          `Budget: ₹${Number(
            intent.max_price
          ).toLocaleString('en-IN')}`
        );
      } else if (intent.budget) {
        chips.push(
          `Budget: ${money(intent.budget)}`
        );
      }

      if (chips.length) {
        html += `
          <div class="bk-ai__intent">
            ${chips
              .map(
                x => `<span>${x}</span>`
              )
              .join('')}
          </div>
        `;
      }
    }

    d.innerHTML = html;

    conversation.appendChild(d);

    scrollBottom();
  }

  function loading(on) {
    const old =
      document.getElementById(
        'bkAiLoading'
      );

    if (!on) {
      if (old) old.remove();
      return;
    }

    if (old) return;

    const d = document.createElement('div');

    d.id = 'bkAiLoading';

    d.className = 'bk-ai__loading';

    d.innerHTML = `
      Thinking and checking live stock
      <span class="bk-ai__dots">
        <i></i><i></i><i></i>
      </span>
    `;

    conversation.appendChild(d);

    scrollBottom();
  }

  function scrollBottom() {
    const body =
      document.getElementById(
        'bkAiBody'
      );

    if (!body) return;

    requestAnimationFrame(() => {
      body.scrollTop = body.scrollHeight;
    });
  }

  function productCard(p, pos) {
    const sizes = (
      p.sizes || []
    ).slice(0, 12);

    const compare =
      Number(p.compare_at_price || 0) >
      Number(p.price || 0)
        ? `
          <span class="bk-ai__compare">
            ${money(p.compare_at_price)}
          </span>
        `
        : '';

    const rootPath =
      (window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      '/';

    const url =
      p.url ||
      `${rootPath}products/${encodeURIComponent(
        p.handle
      )}`;

    return `
      <article
        class="bk-ai__card"
        data-handle="${esc(p.handle)}"
      >
        <div class="bk-ai__image-wrap">
          ${
            p.image
              ? `
                <img
                  class="bk-ai__image"
                  src="${esc(p.image)}"
                  alt="${esc(p.title)}"
                  loading="lazy"
                >
              `
              : ''
          }

          <span class="bk-ai__badge">
            AI Pick
          </span>
        </div>

        <div class="bk-ai__card-content">
          <div class="bk-ai__title">
            ${esc(p.title)}
          </div>

          <div class="bk-ai__price">
            ${money(p.price)}
            ${compare}
          </div>

          <div class="bk-ai__reason">
            ${esc(
              (p.reasons || []).join(' • ') ||
                p.reason ||
                'Recommended for you'
            )}
          </div>

          ${
            sizes.length
              ? `
                <div class="bk-ai__sizes">
                  ${sizes
                    .map(
                      s => `
                        <span class="bk-ai__size">
                          ${esc(s)}
                        </span>
                      `
                    )
                    .join('')}
                </div>
              `
              : ''
          }

          <div class="bk-ai__actions">
            <a
              class="bk-ai__view"
              href="${esc(url)}"
              data-bk-view
              data-handle="${esc(p.handle)}"
              data-position="${pos}"
            >
              View Product
            </a>

            <button
              class="bk-ai__add"
              type="button"
              data-bk-add
              data-variant="${esc(p.variant_id)}"
              data-handle="${esc(p.handle)}"
              data-title="${esc(p.title)}"
              data-position="${pos}"
            >
              Quick Add
            </button>
          </div>
        </div>
      </article>
    `;
  }

  function renderProducts(
    products,
    append = false,
    hasMore = false
  ) {
    const list =
      (products || []).slice(
        0,
        RECOMMENDATION_LIMIT
      );

    const start =
      memory.shown_handles.length;

    const html = list
      .map(
        (p, i) =>
          productCard(
            p,
            start + i + 1
          )
      )
      .join('');

    if (append) {
      results.insertAdjacentHTML(
        'beforeend',
        html
      );
    } else {
      results.innerHTML = html;
    }

    list.forEach((p, i) => {
      if (
        !memory.shown_handles.includes(
          p.handle
        )
      ) {
        memory.shown_handles.push(
          p.handle
        );
      }

      track(
        'recommendation_impression',
        {
          handle: p.handle,
          position: start + i + 1
        }
      );
    });

    const old =
      document.getElementById(
        'bkAiMore'
      );

    if (old) old.remove();

    if (hasMore) {
      const b =
        document.createElement(
          'button'
        );

      b.id = 'bkAiMore';

      b.type = 'button';

      b.className = 'bk-ai__add';

      b.style.cssText =
        'width:100%;min-height:44px;border-radius:12px;margin:2px 0 12px';

      b.textContent =
        'Show more recommendations';

      b.addEventListener(
        'click',
        () => ask('more', true)
      );

      results.appendChild(b);
    }

    saveMemory();

    scrollBottom();
  }

  function normalizeAgeLabel(value) {
    const t = String(value || '')
      .toLowerCase()
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();

    if (!t) return null;

    if (
      /\bnew\s*born\b|\bnewborn\b/.test(t)
    ) {
      return 'Newborn';
    }

    const patterns = [
      [
        /0\s*-\s*3\s*(m|month|months)\b/,
        '0-3M'
      ],
      [
        /0\s*-\s*6\s*(m|month|months)\b/,
        '0-6M'
      ],
      [
        /3\s*-\s*6\s*(m|month|months)\b/,
        '3-6M'
      ],
      [
        /6\s*-\s*9\s*(m|month|months)\b/,
        '6-9M'
      ],
      [
        /6\s*-\s*12\s*(m|month|months)\b/,
        '6-12M'
      ],
      [
        /9\s*-\s*12\s*(m|month|months)\b/,
        '9-12M'
      ],
      [
        /1\s*-\s*2\s*(y|yr|year|years)\b/,
        '1-2Y'
      ],
      [
        /2\s*-\s*3\s*(y|yr|year|years)\b/,
        '2-3Y'
      ],
      [
        /3\s*-\s*4\s*(y|yr|year|years)\b/,
        '3-4Y'
      ],
      [
        /4\s*-\s*5\s*(y|yr|year|years)\b/,
        '4-5Y'
      ],
      [
        /5\s*-\s*6\s*(y|yr|year|years)\b/,
        '5-6Y'
      ]
    ];

    for (const [rx, label] of patterns) {
      if (rx.test(t)) {
        return label;
      }
    }

    if (
      /\b1\s*(y|yr|year|years)\b/.test(t)
    ) {
      return '1-2Y';
    }

    if (
      /\b2\s*(y|yr|year|years)\b/.test(t)
    ) {
      return '2-3Y';
    }

    if (
      /\b3\s*(y|yr|year|years)\b/.test(t)
    ) {
      return '3-4Y';
    }

    if (
      /\b4\s*(y|yr|year|years)\b/.test(t)
    ) {
      return '4-5Y';
    }

    if (
      /\b5\s*(y|yr|year|years)\b/.test(t)
    ) {
      return '5-6Y';
    }

    return null;
  }

  function variantText(v) {
    return [
      v.title,
      v.option1,
      v.option2,
      v.option3
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
  }

  function unique(arr) {
    return [
      ...new Set(
        arr.filter(Boolean)
      )
    ];
  }

  function chooseVariant(
    product,
    intent
  ) {
    const variants = (
      product.variants || []
    ).filter(v => v.available);

    if (!variants.length) {
      return null;
    }

    const wantedAge =
      intent?.age || null;

    const wantedColors = (
      intent?.colors || []
    ).map(x =>
      String(x).toLowerCase()
    );

    let pool = variants;

    if (wantedAge) {
      const ageMatched =
        pool.filter(
          v =>
            normalizeAgeLabel(
              variantText(v)
            ) === wantedAge
        );

      if (ageMatched.length) {
        pool = ageMatched;
      } else {
        return null;
      }
    }

    if (wantedColors.length) {
      const colorMatched =
        pool.filter(v => {
          const t = variantText(v);

          return wantedColors.some(
            c => t.includes(c)
          );
        });

      if (colorMatched.length) {
        pool = colorMatched;
      }
    }

    return pool[0] || null;
  }

  async function enrichBrainProduct(
    p,
    intent
  ) {
    try {
      const rootPath =
        (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root) ||
        '/';

      const r = await fetch(
        `${rootPath}products/${encodeURIComponent(
          p.handle
        )}.js`,
        {
          headers: {
            Accept: 'application/json'
          },
          credentials: 'same-origin'
        }
      );

      if (!r.ok) return null;

      const live = await r.json();

      const v = chooseVariant(
        live,
        intent
      );

      if (!v) return null;

      const sizes = [];

      const opts =
        Array.isArray(live.options)
          ? live.options
          : [];

      const sizePos =
        opts.findIndex(
          o =>
            String(
              o?.name || o
            ).toLowerCase() === 'size'
        );

      if (sizePos >= 0) {
        for (const av of (
          live.variants || []
        ).filter(x => x.available)) {
          const val = [
            av.option1,
            av.option2,
            av.option3
          ][sizePos];

          if (val) sizes.push(val);
        }
      }

      return {
        handle: p.handle,

        title:
          p.title || live.title,

        url:
          p.url ||
          `${rootPath}products/${encodeURIComponent(
            p.handle
          )}`,

        image:
          live.featured_image ||
          (Array.isArray(live.images) &&
            live.images[0]) ||
          '',

        price:
          Number(v.price || 0),

        compare_at_price:
          Number(
            v.compare_at_price || 0
          ),

        variant_id:
          String(v.id || ''),

        sizes:
          unique(sizes),

        reasons: [
          intent?.age
            ? `Size ${intent.age} available`
            : null,

          intent?.category
            ? `Matches ${intent.category}`
            : null,

          intent?.occasion
            ? `Suitable for ${intent.occasion}`
            : null,

          intent?.material
            ? `${intent.material}`
            : null,

          p.new_arrival
            ? 'New arrival'
            : null
        ].filter(Boolean)
      };
    } catch (e) {
      console.warn(
        '[Bowkart Brain enrich]',
        p?.handle,
        e
      );

      return null;
    }
  }

  async function brainRecommend(
    message
  ) {
    const r = await fetch(
      BRAIN_URL,
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json'
        },

        body: JSON.stringify({
          message,

          context:
            memory.context || {},

          exclude_handles:
            memory.shown_handles || [],

          limit:
            RECOMMENDATION_LIMIT
        })
      }
    );

    const data =
      await r
        .json()
        .catch(() => ({}));

    if (!r.ok || !data?.ok) {
      throw new Error(
        data?.detail ||
          data?.error ||
          `Brain ${r.status}`
      );
    }

    return data;
  }

  async function legacyRecommend(
    message
  ) {
    const r = await fetch(
      SHOPPER_URL,
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json'
        },

        body: JSON.stringify({
          message,

          session_id:
            sessionId(),

          context:
            memory.context || {},

          exclude_handles:
            memory.shown_handles || [],

          limit:
            RECOMMENDATION_LIMIT
        })
      }
    );

    const data =
      await r
        .json()
        .catch(() => ({}));

    if (!r.ok || !data?.ok) {
      throw new Error(
        data?.error ||
          `Legacy shopper ${r.status}`
      );
    }

    return data;
  }

  async function ask(
    raw,
    isMore = false
  ) {
    let message =
      String(raw || '').trim();

    if (!message || busy) {
      return;
    }

    const more =
      /^(more|show more|more options|next|another)$/i.test(
        message
      );

    if (
      more &&
      memory.last_query
    ) {
      message =
        memory.last_query;
    } else if (!more) {
      memory.last_query =
        message;

      memory.shown_handles =
        [];

      memory.page = 0;
    }

    busy = true;

    send.disabled = true;

    welcome.style.display =
      'none';

    if (!more) {
      results.innerHTML = '';
    }

    bubble(
      more
        ? 'Show me more options'
        : message,
      'user'
    );

    input.value = '';

    loading(true);

    try {
      let data;

      let usedBrain = true;

      try {
        data =
          await brainRecommend(
            more
              ? 'more'
              : message
          );

        if (
          data.handoff ===
            'support' ||
          data.intent
            ?.intent_type ===
            'support'
        ) {
          loading(false);

          memory.context = {};

          saveMemory();

          bubble(
            data.reply ||
              'This looks like a customer-support question.',
            'ai',
            data.intent
          );

          track(
            'brain_support_handoff'
          );

          return;
        }

        memory.context =
          data.intent || {};

        const enriched =
          await Promise.all(
            (
              data.products || []
            )
              .slice(
                0,
                RECOMMENDATION_LIMIT
              )
              .map(
                p =>
                  enrichBrainProduct(
                    p,
                    data.intent || {}
                  )
              )
          );

        data.products =
          enriched.filter(Boolean);

        data.meta = {
          ...(data.meta || {}),
          has_more:
            Number(
              data.count || 0
            ) >=
            RECOMMENDATION_LIMIT
        };

        track(
          'brain_recommend_success',
          {
            count:
              data.products.length
          }
        );
      } catch (brainError) {
        usedBrain = false;

        console.warn(
          '[Bowkart AI Brain fallback]',
          brainError
        );

        track(
          'brain_recommend_fallback'
        );

        data =
          await legacyRecommend(
            message
          );

        memory.context =
          data.context ||
          data.intent ||
          {};

        if (
          Array.isArray(
            data.products
          )
        ) {
          data.products =
            data.products.slice(
              0,
              RECOMMENDATION_LIMIT
            );
        }
      }

      loading(false);

      memory.page =
        (memory.page || 0) + 1;

      saveMemory();

      bubble(
        data.reply ||
          (
            usedBrain
              ? 'Here are the best live Bowkart matches I found.'
              : 'Here are the best matches I found.'
          ),
        'ai',
        data.intent ||
          memory.context
      );

      renderProducts(
        data.products || [],
        more,
        Boolean(
          data.meta &&
            data.meta.has_more
        )
      );

      if (
        !(
          data.products || []
        ).length
      ) {
        bubble(
          'I couldn’t find an exact live match. Try changing the age, budget, colour, material or occasion.',
          'ai'
        );
      }
    } catch (e) {
      loading(false);

      bubble(
        'I’m having trouble searching right now. Please try again in a moment.',
        'ai'
      );

      console.error(
        '[Bowkart AI Shopper]',
        e
      );
    } finally {
      busy = false;

      send.disabled = false;

      input.focus();
    }
  }

  async function quickAdd(
    button
  ) {
    if (button.disabled) {
      return;
    }

    const variant =
      button.dataset.variant;

    if (!variant) {
      showToast(
        'Open the product to choose a size.',
        true
      );

      return;
    }

    button.disabled = true;

    const old =
      button.textContent;

    button.textContent =
      'Adding...';

    track(
      'shopper_quick_add',
      {
        handle:
          button.dataset.handle,

        position:
          Number(
            button.dataset
              .position || 0
          )
      }
    );

    try {
      const url =
        (
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
        ) ||
        '/';

      const r = await fetch(
        url + 'cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',
            Accept:
              'application/json'
          },

          body:
            JSON.stringify({
              items: [
                {
                  id:
                    String(
                      variant
                    ),
                  quantity: 1
                }
              ]
            })
        }
      );

      const out =
        await r
          .json()
          .catch(() => ({}));

      if (!r.ok) {
        throw new Error(
          out.description ||
            out.message ||
            `Cart add failed ${r.status}`
        );
      }

      track(
        'shopper_quick_add_success',
        {
          handle:
            button.dataset.handle,

          position:
            Number(
              button.dataset
                .position || 0
            )
        }
      );

      showToast(
        `Added ${
          button.dataset.title ||
          'item'
        } to cart`
      );

      button.textContent =
        'Added ✓';

      document.dispatchEvent(
        new CustomEvent(
          'cart:refresh'
        )
      );

      document.dispatchEvent(
        new CustomEvent(
          'cart:updated'
        )
      );

      setTimeout(
        () => {
          button.disabled =
            false;

          button.textContent =
            old;
        },
        1800
      );
    } catch (e) {
      track(
        'shopper_quick_add_error',
        {
          handle:
            button.dataset.handle,

          position:
            Number(
              button.dataset
                .position || 0
            )
        }
      );

      showToast(
        e.message ||
          'Could not add this item.',
        true
      );

      button.disabled = false;

      button.textContent =
        old;
    }
  }

  function track(
    event,
    extra = {}
  ) {
    try {
      fetch(
        EVENT_URL,
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json'
          },

          keepalive: true,

          body:
            JSON.stringify({
              event,

              session_id:
                sessionId(),

              age:
                memory.context?.age ||
                '',

              category:
                memory.context
                  ?.category || '',

              occasion:
                memory.context
                  ?.occasion || '',

              brain_intent_type:
                memory.context
                  ?.intent_type || '',

              ...extra
            })
        }
      ).catch(() => {});
    } catch (_) {}
  }

  launcher.addEventListener(
    'click',
    openDrawer
  );

  closeBtn.addEventListener(
    'click',
    closeDrawer
  );

  overlay.addEventListener(
    'click',
    closeDrawer
  );

  document.addEventListener(
    'keydown',
    e => {
      if (
        e.key === 'Escape' &&
        drawer.classList.contains(
          'is-open'
        )
      ) {
        closeDrawer();
      }
    }
  );

  form.addEventListener(
    'submit',
    e => {
      e.preventDefault();

      ask(input.value);
    }
  );

  root.addEventListener(
    'click',
    e => {
      const p =
        e.target.closest(
          '[data-bk-prompt]'
        );

      if (p) {
        ask(
          p.getAttribute(
            'data-bk-prompt'
          )
        );

        return;
      }

      const a =
        e.target.closest(
          '[data-bk-add]'
        );

      if (a) {
        quickAdd(a);
        return;
      }

      const v =
        e.target.closest(
          '[data-bk-view]'
        );

      if (v) {
        track(
          'shopper_product_click',
          {
            handle:
              v.dataset.handle,

            position:
              Number(
                v.dataset
                  .position || 0
              )
          }
        );
      }
    }
  );
})();